import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ProductVariantDetailsFragmentDoc } from '../../fragments/__generated__/ProductVariant.generated';
import { ProductDetailsFragmentDoc } from '../../fragments/__generated__/ProductDetails.generated';
import { RewardProgramFragmentDoc } from '../../fragments/__generated__/RewardProgram.generated';
import { CartBaseFragmentDoc, CartTotalPriceFragmentDoc } from '../../fragments/__generated__/Cart.generated';
import { CartLineFragmentDoc } from '../../fragments/__generated__/CartLine.generated';
import { CartLinePriceFragmentDoc } from '../../fragments/__generated__/CartLinePrice.generated';
import { ProductVariantPriceRangeFragmentDoc } from '../../fragments/__generated__/ProductVariantPriceRange.generated';
import { ShippingDiscountFragmentDoc } from '../../fragments/__generated__/ShippingDiscount.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CartLineQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type CartLineQuery = { cartLine: { id: string, pk: number, quantity: number, isShippingRequired: boolean, total: { gross: number, currency: string }, supplyParts: Array<{ id: string, pk: number, quantity: number, variant: { id: string, pk: number, name: string, sku: string, weightOverride: number | null, unitCoeff: number | null, wholesaleDescription: string, isCustomizable: boolean, properties: Array<{ id: number, pk: number, attributeName: string, valueName: string }>, priceRange: { currency: string, discount: { min: number, max: number } }, product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, specifics: Array<{ id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string, thumbnail: { lg: string | null, sm: string | null } }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } } }>, variant: { thumbnailUrl: string | null, id: string, pk: number, name: string, sku: string, weightOverride: number | null, unitCoeff: number | null, wholesaleDescription: string, isCustomizable: boolean, properties: Array<{ id: number, pk: number, attributeName: string, valueName: string }>, priceRange: { currency: string, discount: { min: number, max: number } }, product: { weight: number | null, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, manufacturer: { id: string, name: string } | null, specifics: Array<{ id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string, thumbnail: { lg: string | null, sm: string | null } }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } } } | null };

export type CartQueryVariables = Types.Exact<{
  cartType?: Types.InputMaybe<Types.CartTypeEnum>;
  promoCodeToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
  includeLinesByCategory?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type CartQuery = { cart: { linesByCategory?: any, cookieToken: string, id: string, token: any, count: number, quantity: number, type: Types.CartTypeEnum, orderId: number | null, totalPrice: { id: string, promoCodeApplied: number, earnPoints: number, currency: string, undiscount: { currency: string, gross: number }, discount: { currency: string, gross: number }, discountUsd: { currency: string, gross: number } } } };

export type FullCartQueryVariables = Types.Exact<{
  cartType?: Types.InputMaybe<Types.CartTypeEnum>;
  promoCodeToken?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type FullCartQuery = { cart: { id: string, token: any, count: number, totalPrice: { id: string, promoCodeApplied: number, earnPoints: number, currency: string, undiscount: { currency: string, gross: number }, discount: { currency: string, gross: number }, discountUsd: { currency: string, gross: number } }, allLines: Array<{ id: string, pk: number, quantity: number, supplyParts: Array<{ id: string, pk: number, quantity: number, unitPrice: { currency: string, discount: number, undiscount: number }, variant: { id: string, shippingRequired: boolean, stockQuantity: number, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, wholesalePrice: { currency: string, undiscount: number, discount: number }, product: { id: string, pk: number, specifics: Array<{ id: string, pk: number, slug: string, name: string }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } } }>, unitPrice: { currency: string, discount: number, undiscount: number }, variant: { id: string, pk: number, sku: string, isSupply: boolean, shippingRequired: boolean, stockQuantity: number, thumbnailUrl: string | null, isCustomizable: boolean, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, properties: Array<{ id: number, attributeName: string, valueName: string }>, product: { id: string, pk: number, siteSpecifics: Array<{ id: string, pk: number, name: string, shortName: string, slug: string, thumbnailUrl: string | null, categories: Array<{ id: string, name: string, sortOrder: number | null, level: number }> }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> }, wholesalePrice: { currency: string, discount: number, undiscount: number } } }> } };

export type CartLinesQueryVariables = Types.Exact<{
  cartType?: Types.InputMaybe<Types.CartTypeEnum>;
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  supplyIsNull?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  categories?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
  includeSupplyPartDetails?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type CartLinesQuery = { cartLines: { totalCount: number, results: Array<{ id: string, pk: number, quantity: number, supplyParts: Array<{ id: string, pk: number, quantity: number, unitPrice?: { currency: string, discount: number, undiscount: number }, variant: { id: string, shippingRequired?: boolean, stockQuantity?: number, wholesalePrice: { currency: string, undiscount: number, discount: number }, priceRange?: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, product?: { id: string, pk: number, specifics: Array<{ id: string, pk: number, slug: string, name: string }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> } } }>, unitPrice: { currency: string, discount: number, undiscount: number }, variant: { id: string, pk: number, sku: string, isSupply: boolean, shippingRequired: boolean, stockQuantity: number, thumbnailUrl: string | null, isCustomizable: boolean, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, properties: Array<{ id: number, attributeName: string, valueName: string }>, product: { id: string, pk: number, siteSpecifics: Array<{ id: string, pk: number, name: string, shortName: string, slug: string, thumbnailUrl: string | null, categories: Array<{ id: string, name: string, sortOrder: number | null, level: number }> }>, rewardPrograms: Array<{ id: string, pk: number, availableFrom: any | null, availableTo: any | null, coefficient: number, dateCreated: any, daysActive: number, name: string, description: string, isActive: boolean, rdThreshold: number | null, rpThreshold: number, thumbnailUrl: string | null }> }, wholesalePrice: { currency: string, discount: number, undiscount: number } } }> } };

export type CartLineKitContentsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type CartLineKitContentsQuery = { cartLine: { id: string, supplyParts: Array<{ id: string, pk: number, quantity: number, variant: { id: string, wholesalePrice: { currency: string, undiscount: number, discount: number }, product: { id: string, specifics: Array<{ id: string, pk: number, slug: string, name: string }> } } }> } | null };

export type CartShippingDiscountsQueryVariables = Types.Exact<{
  cartType?: Types.InputMaybe<Types.CartTypeEnum>;
}>;


export type CartShippingDiscountsQuery = { cart: { id: string, token: any, totalPrice: { currency: string, discount: { gross: number }, undiscount: { gross: number }, discountUsd: { gross: number } }, shippingDiscounts: Array<{ id: string, pk: number, name: string, discountType: Types.DiscountTypeEnum, isCurrent: boolean, minValue: number, maxValue: number, value: number, shippingMethods: { id: string, pk: number, name: string } }> } };


export const CartLineDocument = gql`
    query CartLine($id: ID!) {
  cartLine(id: $id) {
    id
    pk
    quantity
    isShippingRequired
    total {
      gross
      currency
    }
    supplyParts {
      id
      pk
      quantity
      variant {
        ...ProductVariantDetailsFragment
        ...ProductDetailsFragment
      }
    }
    variant {
      ...ProductVariantDetailsFragment
      ...ProductDetailsFragment
      thumbnailUrl(size: "300x0", method: CROP_WEBP)
    }
  }
}
    ${ProductVariantDetailsFragmentDoc}
${ProductDetailsFragmentDoc}`;

/**
 * __useCartLineQuery__
 *
 * To run a query within a React component, call `useCartLineQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartLineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartLineQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCartLineQuery(baseOptions: Apollo.QueryHookOptions<CartLineQuery, CartLineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartLineQuery, CartLineQueryVariables>(CartLineDocument, options);
      }
export function useCartLineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartLineQuery, CartLineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartLineQuery, CartLineQueryVariables>(CartLineDocument, options);
        }
export type CartLineQueryHookResult = ReturnType<typeof useCartLineQuery>;
export type CartLineLazyQueryHookResult = ReturnType<typeof useCartLineLazyQuery>;
export type CartLineQueryResult = Apollo.QueryResult<CartLineQuery, CartLineQueryVariables>;
export function refetchCartLineQuery(variables: CartLineQueryVariables) {
      return { query: CartLineDocument, variables: variables }
    }
export const CartDocument = gql`
    query Cart($cartType: CartTypeEnum = DEFAULT, $promoCodeToken: String, $includeLinesByCategory: Boolean = false) {
  cart(cartType: $cartType) {
    ...CartBaseFragment
    totalPrice(promoCodeToken: $promoCodeToken) {
      ...CartTotalPriceFragment
    }
    linesByCategory @include(if: $includeLinesByCategory)
    cookieToken
  }
}
    ${CartBaseFragmentDoc}
${CartTotalPriceFragmentDoc}`;

/**
 * __useCartQuery__
 *
 * To run a query within a React component, call `useCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartQuery({
 *   variables: {
 *      cartType: // value for 'cartType'
 *      promoCodeToken: // value for 'promoCodeToken'
 *      includeLinesByCategory: // value for 'includeLinesByCategory'
 *   },
 * });
 */
export function useCartQuery(baseOptions?: Apollo.QueryHookOptions<CartQuery, CartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartQuery, CartQueryVariables>(CartDocument, options);
      }
export function useCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartQuery, CartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartQuery, CartQueryVariables>(CartDocument, options);
        }
export type CartQueryHookResult = ReturnType<typeof useCartQuery>;
export type CartLazyQueryHookResult = ReturnType<typeof useCartLazyQuery>;
export type CartQueryResult = Apollo.QueryResult<CartQuery, CartQueryVariables>;
export function refetchCartQuery(variables?: CartQueryVariables) {
      return { query: CartDocument, variables: variables }
    }
export const FullCartDocument = gql`
    query FullCart($cartType: CartTypeEnum = DEFAULT, $promoCodeToken: String) {
  cart(cartType: $cartType) {
    id
    token
    count
    totalPrice(promoCodeToken: $promoCodeToken) {
      ...CartTotalPriceFragment
    }
    allLines(filters: {supply: {id: {isNull: true}}}) {
      ...CartLine
      supplyParts {
        id
        pk
        quantity
        unitPrice {
          ...CartLinePriceFragment
        }
        variant {
          id
          shippingRequired
          stockQuantity
          priceRange {
            ...ProductVariantPriceRangeFragment
          }
          wholesalePrice {
            currency
            undiscount
            discount
          }
          product {
            id
            pk
            specifics(filters: {siteSpecifics: true}) {
              id
              pk
              slug
              name
            }
            rewardPrograms {
              ...RewardProgramFragment
            }
          }
        }
      }
    }
  }
}
    ${CartTotalPriceFragmentDoc}
${CartLineFragmentDoc}
${CartLinePriceFragmentDoc}
${ProductVariantPriceRangeFragmentDoc}
${RewardProgramFragmentDoc}`;

/**
 * __useFullCartQuery__
 *
 * To run a query within a React component, call `useFullCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useFullCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFullCartQuery({
 *   variables: {
 *      cartType: // value for 'cartType'
 *      promoCodeToken: // value for 'promoCodeToken'
 *   },
 * });
 */
export function useFullCartQuery(baseOptions?: Apollo.QueryHookOptions<FullCartQuery, FullCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FullCartQuery, FullCartQueryVariables>(FullCartDocument, options);
      }
export function useFullCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FullCartQuery, FullCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FullCartQuery, FullCartQueryVariables>(FullCartDocument, options);
        }
export type FullCartQueryHookResult = ReturnType<typeof useFullCartQuery>;
export type FullCartLazyQueryHookResult = ReturnType<typeof useFullCartLazyQuery>;
export type FullCartQueryResult = Apollo.QueryResult<FullCartQuery, FullCartQueryVariables>;
export function refetchFullCartQuery(variables?: FullCartQueryVariables) {
      return { query: FullCartDocument, variables: variables }
    }
export const CartLinesDocument = gql`
    query CartLines($cartType: CartTypeEnum = DEFAULT, $limit: Int!, $offset: Int!, $supplyIsNull: Boolean, $categories: [Int!], $includeSupplyPartDetails: Boolean = true) {
  cartLines(
    pagination: {limit: $limit, offset: $offset}
    cartType: $cartType
    filters: {supply: {id: {isNull: $supplyIsNull}}, categories: $categories}
  ) {
    totalCount
    results {
      ...CartLine
      supplyParts {
        id
        pk
        quantity
        unitPrice @include(if: $includeSupplyPartDetails) {
          ...CartLinePriceFragment
        }
        variant {
          id
          wholesalePrice {
            currency
            undiscount
            discount
          }
          shippingRequired @include(if: $includeSupplyPartDetails)
          stockQuantity @include(if: $includeSupplyPartDetails)
          priceRange @include(if: $includeSupplyPartDetails) {
            ...ProductVariantPriceRangeFragment
          }
          product @include(if: $includeSupplyPartDetails) {
            id
            pk
            specifics(filters: {siteSpecifics: true}) {
              id
              pk
              slug
              name
            }
            rewardPrograms {
              ...RewardProgramFragment
            }
          }
        }
      }
    }
  }
}
    ${CartLineFragmentDoc}
${CartLinePriceFragmentDoc}
${ProductVariantPriceRangeFragmentDoc}
${RewardProgramFragmentDoc}`;

/**
 * __useCartLinesQuery__
 *
 * To run a query within a React component, call `useCartLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartLinesQuery({
 *   variables: {
 *      cartType: // value for 'cartType'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      supplyIsNull: // value for 'supplyIsNull'
 *      categories: // value for 'categories'
 *      includeSupplyPartDetails: // value for 'includeSupplyPartDetails'
 *   },
 * });
 */
export function useCartLinesQuery(baseOptions: Apollo.QueryHookOptions<CartLinesQuery, CartLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartLinesQuery, CartLinesQueryVariables>(CartLinesDocument, options);
      }
export function useCartLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartLinesQuery, CartLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartLinesQuery, CartLinesQueryVariables>(CartLinesDocument, options);
        }
export type CartLinesQueryHookResult = ReturnType<typeof useCartLinesQuery>;
export type CartLinesLazyQueryHookResult = ReturnType<typeof useCartLinesLazyQuery>;
export type CartLinesQueryResult = Apollo.QueryResult<CartLinesQuery, CartLinesQueryVariables>;
export function refetchCartLinesQuery(variables: CartLinesQueryVariables) {
      return { query: CartLinesDocument, variables: variables }
    }
export const CartLineKitContentsDocument = gql`
    query CartLineKitContents($id: ID!) {
  cartLine(id: $id) {
    id
    supplyParts {
      id
      pk
      quantity
      variant {
        id
        wholesalePrice {
          currency
          undiscount
          discount
        }
        product {
          id
          specifics(filters: {siteSpecifics: true}) {
            id
            pk
            slug
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCartLineKitContentsQuery__
 *
 * To run a query within a React component, call `useCartLineKitContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartLineKitContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartLineKitContentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCartLineKitContentsQuery(baseOptions: Apollo.QueryHookOptions<CartLineKitContentsQuery, CartLineKitContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartLineKitContentsQuery, CartLineKitContentsQueryVariables>(CartLineKitContentsDocument, options);
      }
export function useCartLineKitContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartLineKitContentsQuery, CartLineKitContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartLineKitContentsQuery, CartLineKitContentsQueryVariables>(CartLineKitContentsDocument, options);
        }
export type CartLineKitContentsQueryHookResult = ReturnType<typeof useCartLineKitContentsQuery>;
export type CartLineKitContentsLazyQueryHookResult = ReturnType<typeof useCartLineKitContentsLazyQuery>;
export type CartLineKitContentsQueryResult = Apollo.QueryResult<CartLineKitContentsQuery, CartLineKitContentsQueryVariables>;
export function refetchCartLineKitContentsQuery(variables: CartLineKitContentsQueryVariables) {
      return { query: CartLineKitContentsDocument, variables: variables }
    }
export const CartShippingDiscountsDocument = gql`
    query CartShippingDiscounts($cartType: CartTypeEnum = DEFAULT) {
  cart(cartType: $cartType) {
    id
    token
    totalPrice {
      currency
      discount {
        gross
      }
      undiscount {
        gross
      }
      discountUsd {
        gross
      }
    }
    shippingDiscounts {
      ...ShippingDiscountFragment
    }
  }
}
    ${ShippingDiscountFragmentDoc}`;

/**
 * __useCartShippingDiscountsQuery__
 *
 * To run a query within a React component, call `useCartShippingDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartShippingDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartShippingDiscountsQuery({
 *   variables: {
 *      cartType: // value for 'cartType'
 *   },
 * });
 */
export function useCartShippingDiscountsQuery(baseOptions?: Apollo.QueryHookOptions<CartShippingDiscountsQuery, CartShippingDiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CartShippingDiscountsQuery, CartShippingDiscountsQueryVariables>(CartShippingDiscountsDocument, options);
      }
export function useCartShippingDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CartShippingDiscountsQuery, CartShippingDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CartShippingDiscountsQuery, CartShippingDiscountsQueryVariables>(CartShippingDiscountsDocument, options);
        }
export type CartShippingDiscountsQueryHookResult = ReturnType<typeof useCartShippingDiscountsQuery>;
export type CartShippingDiscountsLazyQueryHookResult = ReturnType<typeof useCartShippingDiscountsLazyQuery>;
export type CartShippingDiscountsQueryResult = Apollo.QueryResult<CartShippingDiscountsQuery, CartShippingDiscountsQueryVariables>;
export function refetchCartShippingDiscountsQuery(variables?: CartShippingDiscountsQueryVariables) {
      return { query: CartShippingDiscountsDocument, variables: variables }
    }